/**
 * 관리자 페이지에서 알림
 */
export default class Notification {
    constructor() {
        this.interval = 5000;
    }

    /**
     * 알림목록을 출력한다.
     * @param list
     */
    drawList = function(list){
        const self = this;
        $('#notification_list').html('');

        // 채팅(불러톡)은 종 아이콘이 아니라 별도 채팅 아이콘에 표시한다.
        // type 은 종류 코드(withdraw/chat/…)이고 사람이 읽는 말은 label 이다.
        // 정의는 Provider 클래스(app/Services/AdminTask/Providers/)가 갖는다.
        let chatCnt = 0;
        const bellList = [];
        list.forEach(function (notification) {
            if (notification.type === 'chat') {
                chatCnt += parseInt(notification.cnt, 10);
            } else {
                bellList.push(notification);
            }
        });
        self.drawChatBadge(chatCnt);

        // cnt 값이 0보다 크면 뱃지를 표시하고, 숫자도 업데이트
        if (bellList.length > 0) {
            let totalCnt = 0;

            bellList.forEach(function (notification, index) {
                totalCnt += parseInt(notification.cnt, 10); // 알림 총 개수 계산
                // 처리중이 몇 건인지 같이 보여준다 — 종이 울린다고 아무도 안 잡은 건 아니다
                const doing = parseInt(notification.doing_cnt, 10) || 0;
                const doingTxt = doing ? ` <small class="text-muted">(${doing} 처리중)</small>` : '';
                const html = `
<li>
<a href="${notification.url}">
    <i style="margin-left: 5px;" class="fas fa-envelope text-red"></i> ${notification.label || notification.type} : ${notification.cnt} 건${doingTxt}
</a>
</li>`;

                $('#notification_list').append(html);

                // 구분선 추가 (마지막 항목에는 추가하지 않음)
                if (index < bellList.length - 1) {
                    const divider = document.createElement('div');
                    divider.classList.add('dropdown-divider');
                    $('#notification_list').append(divider);
                }
            });

            // 뱃지와 메시지 업데이트
            // 머리글은 링크다(blade 에서 <a href="/adm/tasks">) — 누르면 알림 모아보기로 간다.
            // 목록 아래에 따로 입구를 두지 않는 이유: 종을 열면 제일 먼저 읽는 줄이 머리글이라
            // 거기가 가장 짧은 동선이다.
            $('#notificationBadge').show().html(totalCnt);
            $('#notificationIcon').removeClass('navgray');
            $('#check_alim').html('알림 ' + totalCnt + '건이 있습니다. <i class="fas fa-angle-right"></i>');
        } else {
            $('#notificationBadge').hide();
            $('#notificationIcon').addClass('navgray');

            $('#check_alim').html('알림이 없습니다. <i class="fas fa-angle-right"></i>');
        }

    }

    /**
     * 채팅 아이콘 뱃지(미확인 방 수) 갱신
     * @param cnt
     */
    drawChatBadge = function(cnt){
        if (cnt > 0) {
            $('#chatBadge').show().html(cnt);
            $('#chatIcon').removeClass('navgray');
        } else {
            $('#chatBadge').hide();
            $('#chatIcon').addClass('navgray');
        }
    }

    /**
     * 알림 목록
     */
    getList = function () {
        const self = this;
        $.ajax({
            url: '/adm/ajax/notification/list',
            method: 'GET',
            dataType: 'json',
            success: function (response) {
                // console.log(response);
                self.drawList(response);
            },
        });

    }

    // updateNotificationList = function() {
    //     $.ajax({
    //         url: `/adm/notification/update/${type}`, // 컨트롤러 라우트에 맞게 URL 설정
    //         method: 'POST', // POST 요청을 권장
    //         dataType: 'json',
    //         success: function (response) {
    //             console.log(`${type} 알림 업데이트 완료`, response);
    //
    //         },
    //     });
    // }

    initAlimHandler = function () {
        const self = this;

        // 메뉴가 열려 있는 지 — 종을 눌러 **고정**한 상태. 호버로 잠깐 연 것은 여기에 안 든다
        let isMenuOpen = false;
        // 고정을 풀고 닫은 직후 — 마우스가 종 위에 그대로 있어 호버가 곧바로 다시 여는 것을 막는다.
        // 종 밖으로 나가면 풀린다
        let hoverMuted = false;

        // 드롭다운 메뉴 토글 — 누르면 고정, 다시 누르면 닫힌다
        $('#notificationIcon').on('click', function (event) {
            event.preventDefault(); // 기본 동작 방지
            isMenuOpen = !isMenuOpen; // 상태 반전
            hoverMuted = !isMenuOpen;
            $('#notificationUl').toggle(isMenuOpen); // 상태에 따라 메뉴 열기/닫기
        });

        // 마우스오버로 메뉴 보이기 (닫힌 상태일 경우만 적용)
        $('#notificationLi').on('mouseover', function () {
            if (!isMenuOpen && !hoverMuted) {
                $('#notificationUl').show();
            }
        });

        // 마우스리브로 메뉴 숨기기 (닫힌 상태일 경우만 적용)
        $('#notificationLi').on('mouseleave', function () {
            hoverMuted = false;
            if (!isMenuOpen) {
                $('#notificationUl').hide();
            }
        });

        // 외부 클릭 시 드롭다운 닫기 — 종 영역(종 + 목록) 안의 클릭은 바깥이 아니다.
        // 없는 요소를 기준으로 봤더니 종을 누른 클릭이 그대로 '바깥' 으로 잡혀 고정이 바로 풀렸다
        $(document).on('click', function(event) {
            if ($(event.target).closest('#notificationLi').length) return;

            isMenuOpen = false; // 상태 초기화
            $('#notificationUl').hide();
        });

        // 일정 간격마다 업데이트
        self.getList(); // 페이지 로드 시 바로 호출
        setInterval(function(){
            self.getList();
        },this.interval);

    }
}
// $noti = NotificationAlim.getInstance();